import axios from 'axios';

async function getCompanyUsers(id) {
  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/admin/company/${id}/users`);

  return data;
}

async function adminCreateUser(payload) {
  return axios.post(`${import.meta.env.VITE_API_URL}/api/admin/user`, payload);
}

function adminRemoveUserFromCompany(userId, companyId) {
  return axios.delete(`${import.meta.env.VITE_API_URL}/api/admin/company/${companyId}/users/${userId}`);
}

export {
  adminCreateUser,
  adminRemoveUserFromCompany,
  getCompanyUsers,
};